import axios from "axios";
import { ENV_REACT_APP } from "../Configurations/ENV_Config";

/**
 * "N permits on public record" for an unclaimed LA home (October 2026). Public
 * and summary-only: the permits themselves open up once the home is claimed.
 * Backed by GET /api/property/:propertyId/permit-summary.
 */
export interface PermitSummary {
  count: number;
  firstYear: number | null;
  lastYear: number | null;
  /** Issued or expired but never signed off: the kind that matters at resale. */
  notFinaledCount: number;
  /** LADBS permit types, most common first, e.g. "Bldg-Alter/Repair". */
  topTypes: string[];
  source: string;
}

/**
 * Whether we read permits for this home's city (the City of LA only, today).
 * When not, where its permits are: the city's permit search or Building &
 * Safety page (`site`), or a web search for it (`searchUrl`). Oct 21, Asher.
 */
export interface PermitCoverage {
  covered: boolean;
  city?: string;
  site?: { name: string; url: string; kind: "search" | "office" } | null;
  searchUrl?: string;
}

export interface PermitInfo {
  summary: PermitSummary | null;
  coverage: PermitCoverage | null;
}

export const fetchPermitInfo = async (propertyId: string): Promise<PermitInfo> => {
  const base = ENV_REACT_APP?.REACT_APP_API_BASE_URL || "";
  const res = await axios.get(`${base}/api/property/${encodeURIComponent(propertyId)}/permit-summary`);
  const s = res.data?.data?.summary;
  return {
    summary: s && s.count > 0 ? (s as PermitSummary) : null,
    coverage: (res.data?.data?.coverage as PermitCoverage) || null,
  };
};

export const fetchPermitSummary = async (propertyId: string): Promise<PermitSummary | null> =>
  (await fetchPermitInfo(propertyId)).summary;
